/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 改标录入列表-查看操作日志 的 **请求配置**
 *
 * @分类 仓储API/改标
 * @请求头 `POST /erp/GaiBiao/logs`
 */
const postLogsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/GaiBiao/logs",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postLogs",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 改标录入列表-查看操作日志 的 **请求函数**
 *
 * @分类 仓储API/改标
 * @请求头 `POST /erp/GaiBiao/logs`
 */
export const postLogs = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postLogsRequestConfig, requestData), ...args);
};
postLogs.requestConfig = postLogsRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/GaiBiao.js